import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const BOOKING_URL = 'https://cryobybreum.planway.com/';

export const TREATMENT_FAQS = {
  'fedtfrysning': {
    badge: 'FAQ • FEDTFRYSNING',
    title: 'Ofte stillede spørgsmål om fedtfrysning',
    subtitle: 'Få svar på de mest almindelige spørgsmål om kryolipolyse, forløb, forventet resultat og sikkerhed hos Cryo by Breum.',
    items: [
      {
        question: 'Hvordan virker fedtfrysning, og hvad sker der med fedtcellerne i kroppen?',
        answer: 'Fedtfrysning (kryolipolyse) virker ved, at det udvalgte fedtlag nænsomt suges ind i en kontrolleret applikator og nedkøles til en temperatur, hvor fedtcellerne krystalliserer og går til grunde uden at skade huden eller det omkringliggende væv. Kroppens eget lymfe- og immunsystem nedbryder og udskiller derefter naturligt de døde fedtceller gennem leveren over de efterfølgende 8-12 uger. Behandlingen giver en målrettet og varig reduktion af fedtdepotets tykkelse på det behandlede område.',
      },
      {
        question: 'Gør en behandling med fedtfrysning ondt, og er der restitutionstid bagefter?',
        answer: 'Selve påsætningen mærkes indledningsvist som et fast vakuumtræk og en markant kulde, men efter blot 5-10 minutter bedøves området helt naturligt af kulden, hvorefter resten af behandlingen er afslappende. Der er ingen reel restitutionstid eller down-time forbundet med fedtfrysning, så du kan umiddelbart vende tilbage til arbejde og dine hverdagsaktiviteter. Let rødme, ømhed eller en forbigående følelsesløshed i det behandlede område kan forekomme i dagene efter, men aftager hurtigt af sig selv.',
      },
      {
        question: 'Hvor mange påsætninger har jeg brug for, og hvornår kan jeg se det færdige resultat?',
        answer: 'Mange oplever en tydelig forbedring allerede efter en enkelt påsætning, men afhængigt af fedtlagets tykkelse og dine personlige målsætninger anbefaler vi typisk 1-3 behandlinger pr. område med 6-8 ugers interval. De første synlige forandringer viser sig som regel efter 3-4 uger, mens det endelige og maksimale resultat vurderes efter 8-12 uger, når kroppen er færdig med at udskille de krystalliserede celler. Ved en indledende samtale i klinikken tilpasser vi forløbet præcist til din kropsbygning.',
      },
      {
        question: 'Hvilke kropsområder kan behandles med fedtfrysning hos Cryo by Breum?',
        answer: 'Fedtfrysning er særligt effektiv til genstridige fedtdepoter, som trods sund kost og regelmæssig motion nægter at slippe taget. Behandlingen er ideel til nedre og øvre mave, dansehåndtag (flankerne), BH-deller på ryggen, inder- og yderlår, bananfolden under ballerne samt overarme og dobbelthage. Vores professionelle og godkendte maskine har ergonomiske applikatorer i flere størrelser, så vi kan forme påsætningen præcist efter dine ønsker og opnå et harmonisk resultat.',
      },
      {
        question: 'Er resultatet af fedtfrysning permanent, og er der personer, der ikke må behandles?',
        answer: 'De fedtceller, der krystalliseres og udskilles ved behandlingen, gendannes ikke, og det opnåede resultat er derfor permanent, forudsat at du opretholder en stabil vægt og en sund livsstil. Fedtfrysning er ikke en slankekur mod generel overvægt, men en målrettet kropskonturering. Behandlingen frarådes ved graviditet og amning, brok i det ønskede område samt alvorlige kuldeoverfølsomhedssygdomme som f.eks. Raynauds syndrom eller kryoglobulinæmi.',
      },
    ],
  },

  'ems-traening': {
    badge: 'FAQ • EMS TRÆNING',
    title: 'Ofte stillede spørgsmål om EMS træning',
    subtitle: 'Få svar på de mest almindelige spørgsmål om elektrisk muskelstimulation, intensitet, forberedelse og resultater hos Cryo by Breum.',
    items: [
      {
        question: 'Hvad er EMS træning, og hvordan adskiller det sig fra traditionel styrketræning?',
        answer: 'EMS (Elektrisk Muskel Stimulation) sender kontrollerede, lavfrekvente impulser til kroppens store muskelgrupper via en specialudviklet træningsdragt, mens du laver guidede kropsvægtsøvelser. Hvor almindelig fitness primært aktiverer de yderste muskellag, aktiverer EMS op mod 90% af kroppens muskelmasse samtidigt – inklusive de dybe, stabiliserende kernemuskler. Derfor opnår du på blot 20-25 minutters intensiv EMS træning en muskelaktivering, som svarer til adskillige timers traditionel træning i fitnesscentret.',
      },
      {
        question: 'Gør de elektriske impulser ondt under træningen, og hvordan føles det?',
        answer: 'Impulserne gør ikke ondt, men opleves som en dyb, prikkende vibration efterfulgt af en markant og kontrolleret sammentrækning i musklerne. Vores personlige instruktør er ved din side under hele forløbet og justerer impulsstyrken separat for hver muskelgruppe (f.eks. ben, ryg, mave og arme), så intensiteten passer til netop dit niveau. Træningen foregår i et trygt, kontrolleret tempo, hvor vi hele tiden sikrer, at du føler dig komfortabel og udfordret på den rigtige måde.',
      },
      {
        question: 'Hvor ofte må jeg træne EMS, og hvornår kan jeg forvente at mærke resultater?',
        answer: 'Grundet den ekstraordinært dybe muskelaktivering og den høje intensitet anbefaler vi maksimalt 1-2 EMS træninger om ugen for at give kroppen tilstrækkelig tid til at restituere og opbygge styrke. De fleste mærker allerede en mærkbar forbedring i kropsholdning, muskeltonus og fysisk overskud efter blot 4-6 sessioner. Træningsformen er særligt ideel til travle mennesker med en hektisk hverdag, der ønsker mærkbare resultater uden at skulle bruge timer i et fitnesscenter hver uge.',
      },
      {
        question: 'Er EMS træning velegnet, hvis jeg har skader eller ryg- og ledsmerter?',
        answer: 'EMS træning er særdeles skånsom for leddene, fordi al muskelmodstand skabes via de bioelektriske impulser frem for tunge vægte eller hårde stød mod knogler og sener. Metoden anvendes ofte inden for fysioterapi og genoptræning og er ideel til personer med lændesmerter eller svag kernemuskulatur, da de dybe rygmuskler styrkes effektivt uden risiko for overbelastning. Vi tilpasser altid øvelserne individuelt under hensyntagen til eventuelle fysiske gener.',
      },
      {
        question: 'Hvad skal jeg medbringe til en EMS session, og hvem må ikke træne EMS?',
        answer: 'Du behøver kun medbringe et par indendørs træningssko eller skridsikre sokker – vi stiller det specielle undertøj, EMS-dragten og håndklæder til rådighed i klinikken. Vi anbefaler desuden, at du drikker rigeligt med vand både før og efter træningen for optimal væskebalance og muskelrestitution. EMS frarådes for personer med pacemaker eller anden implanteret hjertestarter, gravide, personer med epilepsi, akutte betændelsestilstande eller alvorlige kredsløbssygdomme.',
      },
    ],
  },

  'body-roll': {
    badge: 'FAQ • BODY ROLL',
    title: 'Ofte stillede spørgsmål om Body Roll',
    subtitle: 'Få svar på de mest almindelige spørgsmål om lymfedrænende rullemassage, infrarød varme, påklædning og forløb hos Cryo by Breum.',
    items: [
      {
        question: 'Hvad er Body Roll, og hvordan fungerer den mekaniske rullemassage?',
        answer: 'Body Roll er en dybdegående rullemassage, der kombinerer anatomisk formede trævalser med målrettet infrarød varme og lysterapi. Maskinen roterer i et stabilt tempo, mens du guides igennem en fast sekvens af ergonomiske stillinger, der systematisk bearbejder fødder, lægge, lår, baller, mave, ryg og arme. Det mekaniske tryk stimulerer kroppens lymfesystem og øger blodcirkulationen markant, hvilket hjælper kroppen med at bortlede ophobet væske og affaldsstoffer fra vævet.',
      },
      {
        question: 'Hvilke fordele giver Body Roll mod væskeophobninger og cellulitis?',
        answer: 'Den intensive lymfestimulering og den dybe bindevævsmassage gør Body Roll særligt effektiv til at mindske hævede ben, reducere væskeophobninger og udglatte ujævnheder i huden såsom appelsinhud (cellulite). Den infrarøde varme trænger dybt ind i muskelvævet, hvor den øger elasticiteten, fremmer fedtforbrændingen og stimulerer kroppens naturlige kollagenproduktion. Resultatet er en fastere, glattere hudstruktur og en mærkbar følelse af lethed og velvære i hele kroppen.',
      },
      {
        question: 'Gør behandlingen ondt, og hvordan forbereder jeg mig til en session?',
        answer: 'Rullemassagen er overvejende en behagelig og afslappende oplevelse, men på områder med mange myoser eller ophobet væske kan det føles let intenst i starten. Du bestemmer dog altid selv trykket ved at justere, hvor meget af din egen kropsvægt du lægger mod trævalserne. Til sessionen skal du bære tætsiddende træningstøj uden lynlåse (f.eks. leggings og langærmet bluse) samt rene sokker, og vi anbefaler at have opsat hår for maksimal sikkerhed og komfort.',
      },
      {
        question: 'Hvor lang tid varer en session, og hvor mange behandlinger anbefales der?',
        answer: 'En standard Body Roll session varer enten 30 eller 45 minutter, hvor hver kropszone bearbejdes i cirka 3-4 minutter i en nøje tilrettelagt rækkefølge, der følger lymfebanernes naturlige retning mod hjertet. For et optimalt resultat i forhold til opstramning, udrensning og restitution anbefaler vi et sammenhængende forløb på 6-10 behandlinger med 1-2 ugentlige sessioner. Efterfølgende kan effekten nemt vedligeholdes med 1-2 månedlige opfølgende rullesessioner.',
      },
      {
        question: 'Hvad skal jeg gøre efter rullemassagen, og hvem frarådes Body Roll?',
        answer: 'Da behandlingen sætter kraftigt gang i kroppens udskillelsesprocesser, er det meget vigtigt at drikke mindst 1,5-2 liter vand efter hver session for at støtte nyrerne og lymfesystemet i at udskille de frigivne affaldsstoffer. Body Roll frarådes gravide, personer med udtalte og smertefulde åreknuder i benene, ubehandlet forhøjet blodtryk, tendens til blodpropper samt ved akut feber eller igangværende infektioner. Har du tvivlsspørgsmål, rådgiver vi dig altid gerne inden start.',
      },
    ],
  },

  'default': {
    badge: 'FAQ • SPØRGSMÅL & SVAR',
    title: 'Ofte stillede spørgsmål',
    subtitle: 'Få svar på de mest almindelige spørgsmål om vores professionelle kropsbehandlinger, forberedelse og tryghed hos Cryo by Breum.',
    items: [
      {
        question: 'Hvordan foregår en typisk behandling hos Cryo by Breum i Odense?',
        answer: 'Når du ankommer til vores klinik på Dalumvej 82 i Odense SV, starter vi altid med en kort samtale om dine ønsker og dit helbred, så vi kan tilpasse behandlingen præcist til dig. Herefter guider vores erfarne personale dig trygt igennem hele sessionen i rolige og behagelige omgivelser. Vi lægger stor vægt på grundig instruktion og tryghed, så du kan koble helt fra og få det maksimale udbytte af dit besøg.',
      },
      {
        question: 'Hvilket udstyr og hvilke sikkerhedskrav anvendes i klinikken?',
        answer: 'Hos Cryo by Breum benytter vi udelukkende godkendt, professionelt og gennemtestet apparatur, der overholder alle gældende standarder for kropsbehandlinger. Udstyret kontrolleres og vedligeholdes løbende, og vores personale er grundigt uddannet i betjeningen og de fysiologiske principper bag hver behandling. Din sikkerhed, komfort og velvære er altid vores absolut højeste prioritet under hele dit besøg.',
      },
      {
        question: 'Hvordan forbereder jeg mig bedst inden mit besøg hos jer?',
        answer: 'Vi anbefaler generelt, at du sørger for at være godt hydreret ved at drikke rigeligt med vand før dit besøg, og at du undgår tunge måltider umiddelbart inden behandlingen. Mød gerne op i behageligt tøj, som er let at skifte, hvis behandlingen kræver det. Har du særlige skavanker, kroniske sygdomme eller tager fast medicin, bedes du informere os om dette forud for behandlingen, så vi kan tage højde for det.',
      },
      {
        question: 'Kan jeg kombinere forskellige behandlinger som f.eks. EMS, Body Roll og fedtfrysning?',
        answer: 'Ja, mange af vores behandlinger komplementerer hinanden særdeles godt og giver en mærkbar synergieffekt for kroppen. For eksempel er Body Roll fantastisk som forberedende eller efterfølgende lymfedrænage i forbindelse med et fedtfrysningsforløb, ligesom det fremmer muskelrestitutionen markant efter en hård EMS træningssession. Vi sammensætter gerne et skræddersyet forløb med fordelagtige pakkepriser, der matcher dine personlige mål.',
      },
      {
        question: 'Hvordan booker jeg tid, og hvilke regler gælder for afbud?',
        answer: 'Du kan nemt og hurtigt booke dine tider døgnet rundt via vores online Planway bookingsystem, som du finder direkte links til her på hjemmesiden. Skulle du blive forhindret i at møde op, beder vi dig venligst melde afbud senest 24 timer før den aftalte tid via bookingsystemet eller telefonisk. På den måde har vi mulighed for at tilbyde tiden til en anden klient fra vores venteliste.',
      },
    ],
  },
};

export default function TreatmentFaq({ slug, treatmentTitle }) {
  const faqData = TREATMENT_FAQS[slug] || {
    ...TREATMENT_FAQS['default'],
    title: treatmentTitle ? `Ofte stillede spørgsmål om ${treatmentTitle}` : TREATMENT_FAQS['default'].title,
  };

  // Keep first question open by default for immediate preview and engaging UX
  const [openItems, setOpenItems] = useState({ 0: true });

  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Structured Data (Schema.org FAQPage) for Google Rich Snippets
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqData.items.map((item) => ({
      '@type': 'Question',
      'name': item.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': item.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-20 sm:py-24 bg-cream border-t border-taupe-border/80">
      {/* Schema.org FAQ structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-12 sm:mb-16 reveal-on-scroll">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-sand border border-taupe-border text-[11px] font-semibold text-espresso uppercase tracking-widest">
            <i className="fa-solid fa-circle-question text-accent-gold text-xs" aria-hidden="true" />
            <span>{faqData.badge}</span>
          </div>

          <h2 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
            {faqData.title}
          </h2>

          <p className="text-taupe text-sm sm:text-base leading-relaxed max-w-2xl mx-auto">
            {faqData.subtitle}
          </p>
        </div>

        {/* 5 FAQ Accordion Items */}
        <div className="space-y-4 reveal-on-scroll delay-100">
          {faqData.items.map((item, index) => {
            const isOpen = Boolean(openItems[index]);
            const numberFormatted = String(index + 1).padStart(2, '0');

            return (
              <div
                key={index}
                className={`border transition-colors duration-200 bg-warm-beige ${
                  isOpen ? 'border-espresso/40 shadow-xs' : 'border-taupe-border/80 hover:border-espresso/30'
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggleItem(index)}
                  className="w-full p-5 sm:p-6 flex items-start sm:items-center justify-between gap-4 text-left group cursor-pointer focus:outline-hidden"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${slug}-${index}`}
                >
                  <div className="flex items-start sm:items-center gap-3 sm:gap-4 flex-1">
                    <span className="font-sans text-xs sm:text-sm font-semibold text-accent-gold tracking-widest shrink-0 mt-0.5 sm:mt-0">
                      {numberFormatted}
                    </span>
                    <h3 className="font-sans text-sm sm:text-base font-semibold text-espresso tracking-wide group-hover:text-accent-brown transition-colors">
                      {item.question}
                    </h3>
                  </div>

                  <span
                    className={`shrink-0 w-8 h-8 flex items-center justify-center border transition-all duration-300 ${
                      isOpen
                        ? 'bg-espresso text-cream border-espresso'
                        : 'bg-sand text-espresso border-taupe-border group-hover:bg-sand-dark'
                    }`}
                  >
                    <i
                      className={`fa-solid fa-chevron-down text-xs transition-transform duration-300 ${
                        isOpen ? 'rotate-180 text-cream' : 'text-espresso'
                      }`}
                      aria-hidden="true"
                    />
                  </span>
                </button>

                {isOpen && (
                  <div
                    id={`faq-answer-${slug}-${index}`}
                    className="px-5 pb-6 sm:px-6 sm:pb-6 pt-1 border-t border-taupe-border/50 animate-in fade-in duration-200"
                  >
                    <p className="text-taupe text-sm sm:text-base leading-relaxed pl-7 sm:pl-8">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Micro-CTA footer within FAQ */}
        <div className="mt-12 p-6 sm:p-8 bg-sand border border-taupe-border/80 text-center space-y-4 reveal-on-scroll delay-150">
          <h4 className="font-sans text-base sm:text-lg font-semibold text-espresso uppercase tracking-wider">
            Har du andre spørgsmål til {treatmentTitle || 'behandlingen'}?
          </h4>
          <p className="text-taupe text-xs sm:text-sm max-w-xl mx-auto leading-relaxed">
            Vi står altid klar til at rådgive dig personligt om forløb, kontraindikationer og priser i klinikken på Dalumvej 82 i Odense SV.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-1">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-espresso text-cream text-xs uppercase tracking-widest font-semibold hover:bg-espresso-light transition-colors"
            >
              <span>Kontakt os her</span>
              <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
            </Link>
            <a
              href="tel:+4528186175"
              className="inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-transparent text-espresso text-xs uppercase tracking-widest font-semibold border border-espresso hover:bg-cream transition-colors"
            >
              <i className="fa-solid fa-phone text-[10px] text-accent-brown" aria-hidden="true" />
              <span>Ring 28 18 61 75</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
